import React from "react";

/**
 * SkipLink - Accessibility component for keyboard navigation
 * Allows users to skip directly to main content
 */
const SkipLink = () => (
    <a
        href="#main-content"
        className="skip-link sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-emerald-main focus:text-black focus:rounded-md focus:font-semibold focus:shadow-lg"
        aria-label="Skip to main content"
    >
        Skip to main content
    </a>
);

export default SkipLink;
